export default __webpack_public_path__ + "images/e-money.212bf085469ca33ad4e3f25bb208b04c.jpeg";